/**
 * Extract a query parameter value from the current URL
 * @param paramName - The name of the query parameter to extract
 * @returns The value of the parameter or null if not found
 */
export const getQueryParam = (paramName: string): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(paramName);
};

/**
 * Check if a string is a valid UUID format
 * @param uuid - The string to validate
 * @returns True if the string is a valid UUID format
 */
export const isValidUUID = (uuid: string): boolean => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(uuid);
};

/**
 * Turn a crawl name into a URL slug, e.g. "The Sawley Shuffle" -> "the-sawley-shuffle"
 */
export const slugify = (name: string): string => {
  return name
    .toLowerCase()
    .replace(/['’]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};
